












































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Blockchain from '@/js/Blockchain'
import Indexed from '@/components/Blockchain/Indexed.vue'

@Component({
    components: {
        Indexed,
    },
})
export default class Metadata extends Vue {
    @Prop() blockchain!: Blockchain

    get validatorsCount() {
        return this.$store.state.Platform.subnets[this.blockchain.subnetID]
            .validators.length
    }
}
